import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'styled-components';

import IconsLibrary from 'components/Icon/IconsLibrary';
import TransProvider from 'translations';
import App from './components/App';

import { GlobalStyles, theme } from './styles';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalStyles />
    <ThemeProvider theme={theme}>
      <TransProvider>
        <App />
      </TransProvider>
      <IconsLibrary />
    </ThemeProvider>
  </React.StrictMode>,
);
